// @ts-nocheck
import React from 'react';
import { Box, Typography } from '@mui/material';
import { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Housing } from '../../api/types';
import { COLORS } from '../../theme';
import { H2 } from '../typography';
import { FORM_STYLES } from '../../styles/formStyles';

// Import new section components
import { HousingSection } from './sections/HousingSection';
import { RentalPeriodSection } from './sections/RentalPeriodSection';
// ApartmentInfoSection flyttad till steg 2

type Reason = {
  title: string;
  value: string;
};

export type FormValues = {
  fromDate: Dayjs;
  toDate: Dayjs;
  selectedAssociation: string;
  selectedApartment: string;
  address: string;
  zipCode: string;
  city: string;
  reason: string;
  tenantFirstName: string;
  tenantLastName: string;
  tenantPhoneNumber: string;
  tenantEmail: string;
  tenantEmailConfirm: string;
  tenantPersonalNumber: string;
  squareMeter: number;
  rooms: number;
  // Avtalsperiod (inom uthyrningsperioden från steg 1)
  contractStartDate: Dayjs;
  contractEndDate: Dayjs;
  rentalFee: number;
  deposit: number;
  clearingnummer: string;
  bankAccountNumber: string;
  bankgiro: string;
  heatingIncluded: boolean;
  hotWaterIncluded: boolean;
  electricityIncluded: boolean;
  internetIncluded: boolean;
  parkingIncluded: boolean;
  furnitureIncluded: boolean;
  miscellaneousNotes: string;
};

type CreateStep1Props = {
  values: FormValues;
  housingList: Housing[];
  associationsList: string[];
  availableApartments: Housing[];
  reasons: Reason[];
  handleChange: (name: string) => (value: string | number | boolean) => void;
  setOtherReason: (val: string | null) => void;
  otherReason: string | null;
  onAssociationChange: (association: string) => void;
  submitButton?: React.ReactNode;
};

export const CreateStep1V3: React.FC<CreateStep1Props> = ({
  values,
  housingList,
  associationsList,
  availableApartments,
  reasons,
  handleChange,
  setOtherReason,
  otherReason,
  onAssociationChange,
  submitButton
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={FORM_STYLES.layout.container}>

      {/* All form sections */}
      <HousingSection
        values={values}
        handleChange={handleChange}
        setOtherReason={setOtherReason}
        otherReason={otherReason}
        associationsList={associationsList}
        availableApartments={availableApartments}
        reasons={reasons}
        onAssociationChange={onAssociationChange}
      />

      <RentalPeriodSection
        values={values}
        handleChange={handleChange}
      />

      {/* Submit button inside the last section */}
      {submitButton && (
        <Box sx={{
          mt: 3,
          pt: 2.5,
          borderTop: '1px solid #E8E8E8',
          display: 'flex',
          justifyContent: 'center'
        }}>
          {submitButton}
        </Box>
      )}

      {/* Lägenhetsinformation flyttad till steg 2 */}
      {/* Ekonomi-sektioner flyttade till steg 2 */}
    </Box>
  );
}; 